import {SimpleSlider} from '../../../components/slider.tsx';
import styles from './features_slider.module.scss';
import {FeatureCard} from './feature_card.tsx';
import {__, transString} from '../../../support/lang/translations.ts';
import {useAppSelector} from '../../../store/store.ts';

export function FeaturesSlider() {
    const newsState = useAppSelector((state) => state.news);
    const reviewsState = useAppSelector((state) => state.reviews);
    const locationState = useAppSelector((state) => state.appConfig.locations);

    const showNews = (newsState.newsPageInfo?.count ?? 0) > 0 || (newsState.news?.length ?? 0) > 0;
    const showOccasions = locationState?.some((l) => (l?.occasion_key?.length ?? 0) > 0) ?? false;
    const showReviews =
        (reviewsState.review?.numberOfReviews ?? 0) > 0 || (reviewsState.review?.reviewList?.length ?? 0) > 0;
    const showPlanner =
        locationState?.some((l) => l?.specialties?.some((s) => (s?.activities?.length ?? 0) > 0)) ?? false;

    return (
        <div className={styles.features_slider}>
            <div className={styles.features_slider__title}>
                <h2>{__('dashboard.titles.features')}</h2>
            </div>
            <SimpleSlider className={'dashboard-features-slider'} slides={3} infinite={false}>
                {showOccasions && (
                    <FeatureCard icon="fa-light fa-car-alt" title={transString('nav.occasions')} to="occasions" />
                )}
                {showPlanner && (
                    <FeatureCard
                        icon="fa-light fa-calendar-days"
                        title={transString('nav.appointment')}
                        to="appointment"
                    />
                )}
                <FeatureCard icon="fa-light fa-phone" title={transString('nav.contact')} to="contact" />
                {showNews && <FeatureCard icon="fa-light fa-newspaper" title={transString('nav.news')} to="news" />}
                {showReviews && <FeatureCard icon="fa-light fa-star" title={transString('nav.reviews')} to="reviews" />}
                <FeatureCard icon="fa-light fa-exclamation-triangle" title={transString('nav.damage')} to="damage" />
                <FeatureCard icon="fa-light fa-lightbulb" title={transString('nav.faults')} to="faults" />
            </SimpleSlider>
        </div>
    );
}
